import { isHeroBrandEnabled } from './heroBrandUtils';

/**
 * Whether the logged-in customer may use the translations feature (TUL-5275).
 *
 * Single source of truth shared by the sidebar menu item and the translation
 * pages (/translations, /translations/:id, /order-translation): if the sidebar
 * would not show Translations, direct URLs must not work either. Interpreters
 * are gated separately — they access their own orders without a userGroup flag.
 *
 * @param {object|null} user The AppContext user.
 * @returns {boolean} True for a hero-brand customer whose business type has
 *   translations enabled.
 */
export const canAccessTranslations = (user) =>
  user?.type === 'Customer' && isHeroBrandEnabled() && !!user?.userGroup?.translationEnabled;

export default canAccessTranslations;
